export default {
  CREATE_PRODUCT: 'PRODUCT/CREATE_PRODUCT',
  DELETE_PRODUCT: 'PRODUCT/DELETE_PRODUCT',
  UPDATE_PRODUCT: 'PRODUCT/UPDATE_PRODUCT',
  UPDATE_ORDER_PRODUCT: 'PRODUCT/UPDATE_ORDER_PRODUCT',
  DELETE_ORDER_PRODUCT: 'PRODUCT/DELETE_ORDER_PRODUCT',
  ADD_ORDER_PRODUCT: 'PRODUCT/ADD_ORDER_PRODUCT',
  UPDATE_LIST: 'PRODUCT/UPDATE_LIST',
  UPDATE_ALL_PRODUCT: 'UPDATE_ALL_PRODUCT'
};
